// AUTO-GENERATED by asyncapi-cable from the cable AsyncAPI documents.
// Do not edit by hand — regenerate with the asyncapi-cable CLI.

import { Channel } from "@anycable/core";
import type { Model } from "../models/Model";

/** Alternatives declared for the operation — AsyncAPI treats a channel's messages as a union. */
export type OnSaleData = Model;

/** Params the client supplies at subscribe time. */
export type OnSaleParams = Record<string, never>;

export class OnSaleChannel extends Channel<OnSaleParams, OnSaleData> {
  static identifier = "OnSaleChannel";
}
